import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MainScreen from "./screens/MainScreen";
import LoginScreen from "./screens/LoginScreen";
import SignUpScreen from "./screens/SignUpScreen";
import Dashboard from "./screens/Dashboard";
import EmailPrevareIntro from "./screens/EmailPrevareIntro";
import EmailPrevareIntroV2 from "./screens/EmailPrevareIntroV2";
import EmailNextScreen from "./screens/EmailNextScreen";
import QuestionsScreen from "./screens/QuestionsScreen";
import ResultsScreen from "./screens/ResultsScreen";
import EmailFinals from "./screens/EmailFinals";
import Privacy from "./screens/Privacy";
import DeleteAccountScreen from "./screens/DeleteAccountScreen";
import MalwareIntro from "./screens/MalwareIntro";
import MalwareNextScreen from "./screens/MalwareNextScreen";
import PasswordSecurityIntro from "./screens/PasswordSecurityIntro";
import PasswordSecurityNextScreen from "./screens/PasswordSecurityNextScreen";
import SocialNetworksIntro from "./screens/SocialNetworksIntro";
import SocialNetworksNextScreen from "./screens/SocialNetworksNextScreen";
import MalwareFinal from "./screens/MalwareFinal";
import PasswordSecurityFinal from "./screens/PasswordSecurityFinal";
import SocialNetworkFinal from "./screens/SocialNetworkFinal";
import CyberAwarenessIntro from "./screens/CyberAwarenessIntro";
import EksterniMedijiIntro from "./screens/EksterniMedijiIntro";
import MobilniUredjajiIntro from "./screens/MobilniUredjajiIntro";
import KoristenjeInternetaIntro from "./screens/KoristenjeInternetaIntro";
import SigurnostKontrolaPristupaIntro from "./screens/SigurnostKontrolaPristupaIntro";
import KoristenjeWiFiIntro from "./screens/KoristenjeWiFi";
import PraviloCistogStolaIntro from "./screens/PraviloCistogStolaIntro";
import KoristenjePodatakaIntro from "./screens/KoristenjePodatakaIntro";
import KoristenjeLicnihUredjajaIntro from "./screens/KoristenjeLicnihUredjajaIntro";
import UdaljenaLokacijaIntro from "./screens/UdaljenaLokacijaIntro";
import ExpertLevelIntro from "./screens/ExpertLevelIntro";
import BonusTextScreen from "./screens/BonusTextScreen";
import BonusFinalScreen from "./screens/BonusFinalScreen";
import UserProfile from "./screens/UserProfile";
import CyberAwarenessIntroDashboard from "./screens/CyberAwarenessIntroDashboard";
import PersonalFreeNextScreen from "./screens/PersonalFreeNextScreen";
import CyberAwarenessPersonalIntro from "./screens/CyberAwarenessPersonalIntro";
import PersonalFinalScreen from "./screens/PersonalFinalScreen";
import CyberAwarenessBusinessIntro from "./screens/CyberAwarenessBusinessIntro";
import BusinessFreeNextScreen from "./screens/BusinessFreeNextScreen";
import BusinessFinalScreen from "./screens/BusinessFinalScreen";


// Funkcija za zaštitu ruta (samo ako je korisnik prijavljen)
const PrivateRoute = ({ element }) => {
  return localStorage.getItem("token") ? element : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/signup" element={<SignUpScreen />} />
        <Route path="/dash" element={<PrivateRoute element={<Dashboard />} />} />
        <Route path="/email-prevare-intro" element={<PrivateRoute element={<EmailPrevareIntro />} />} />
        <Route path="/email-prevare-intro2" element={<PrivateRoute element={<EmailPrevareIntroV2 />} />} />
        <Route path="/email-next-screen" element={<PrivateRoute element={<EmailNextScreen />} />} />
        <Route path="/questions" element={<PrivateRoute element={<QuestionsScreen />} />} />
        <Route path="/results" element={<PrivateRoute element={<ResultsScreen />} />} />
        <Route path="/email-final" element={<PrivateRoute element={<EmailFinals />} />} />
         <Route path="/privacy" element={<Privacy />} />
        <Route path="/delete-account" element={<PrivateRoute element={<DeleteAccountScreen />} />} />
        <Route path="/malware-intro" element={<PrivateRoute element={<MalwareIntro />} />} />
        <Route path="/malware-next-screen" element={<PrivateRoute element={<MalwareNextScreen />} />} />
        <Route path="/password-security-intro" element={<PrivateRoute element={<PasswordSecurityIntro />} />} />
        <Route path="/password-security-next-screen" element={<PrivateRoute element={<PasswordSecurityNextScreen />} />} />
        <Route path="/social-networks-intro" element={<PrivateRoute element={<SocialNetworksIntro />} />} />
        <Route path="/social-networks-next-screen" element={<PrivateRoute element={<SocialNetworksNextScreen />} />} />
        <Route path="/malware-final-screen" element={<PrivateRoute element={<MalwareFinal />} />} />
        <Route path="/password-security-final-screen" element={<PrivateRoute element={<PasswordSecurityFinal />} />} />
        <Route path="/social-network-final-screen" element={<PrivateRoute element={<SocialNetworkFinal />} />} />
        <Route path="/cyber-awareness-intro" element={<PrivateRoute element={<CyberAwarenessIntro />} />} />
        <Route path="/eksterni-mediji-intro" element={<PrivateRoute element={<EksterniMedijiIntro />} />} />
        <Route path="/mobilni-uredjaji-intro" element={<PrivateRoute element={<MobilniUredjajiIntro />} />} />
        <Route path="/koristenje-interneta-intro" element={<PrivateRoute element={<KoristenjeInternetaIntro />} />} />
        <Route path="/sigurnost-kontrola-intro" element={<PrivateRoute element={<SigurnostKontrolaPristupaIntro />} />} />
        <Route path="/koristenje-wifi-intro" element={<PrivateRoute element={<KoristenjeWiFiIntro />} />} />
        <Route path="/pravilo-cistog-stola-intro" element={<PrivateRoute element={<PraviloCistogStolaIntro />} />} />
        <Route path="/koristenje-podataka-intro" element={<PrivateRoute element={<KoristenjePodatakaIntro />} />} />
        <Route path="/koristenje-uredjaja-intro" element={<PrivateRoute element={<KoristenjeLicnihUredjajaIntro />} />} />
        <Route path="/udaljena-lokacija-intro" element={<PrivateRoute element={< UdaljenaLokacijaIntro/>} />} />
        <Route path="/ekspert-level-intro" element={<PrivateRoute element={< ExpertLevelIntro/>} />} />
        <Route path="/bonus-text-screen" element={<PrivateRoute element={< BonusTextScreen/>} />} />
        <Route path="/bonus-final" element={<PrivateRoute element={< BonusFinalScreen/>} />} />
        <Route path="/user-profile" element={<PrivateRoute element={< UserProfile/>} />} />
        <Route path="/intro-dash" element={<PrivateRoute element={< CyberAwarenessIntroDashboard/>} />} />
        <Route path="/personal-free" element={<PrivateRoute element={< PersonalFreeNextScreen/>} />} />
        <Route path="/personal-intro" element={<PrivateRoute element={< CyberAwarenessPersonalIntro/>} />} />
        <Route path="/personal-final" element={<PrivateRoute element={< PersonalFinalScreen/>} />} />
        <Route path="/business-intro" element={<PrivateRoute element={< CyberAwarenessBusinessIntro/>} />} />
        <Route path="/business-free" element={<PrivateRoute element={< BusinessFreeNextScreen/>} />} />
         <Route path="/business-final" element={<PrivateRoute element={< BusinessFinalScreen/>} />} />

        <Route path="" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;